import { useHostProps } from '~features/host-props';
import { Platform } from '~types';

export const useIsMobilePlatform = () => {
  const { platform } = useHostProps();

  return platform === Platform.MOBILE;
};
